<tt-page *ngIf="!!page">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
        <ng-container *ngTemplateOutlet="lists"></ng-container>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="choicepossrulesrun_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="40">
                    <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
                    <ng-container *ngTemplateOutlet="lists"></ng-container>
                </tt-divider-pane>

                <tt-divider-pane ttSize="60"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #selectionCriterias>
    <ng-container *ngIf="!!page">
        <tt-card>
            <tt-select ttLabel="choice_prod_name"
                       [(ttModel)]="page.choice_prod_id"
                       (ttModelChange)="onPageChanged($event, 'choice_prod_id')"
                       [ttData]="selectListProductChoices"
                       ttDataId="prod_id"
                       ttDataName="prod_name"
                       [ttShowClearButton]="page.choice_prod_id !== 'ALL'"
                       ttClearValue="ALL"></tt-select>
            <tt-select ttLabel="model_name"
                       [(ttModel)]="page.model_id"
                       (ttModelChange)="onPageChanged($event, 'model_id')"
                       [ttData]="selectListModels"
                       ttDataId="model_id"
                       ttDataName="model_name"
                       [ttShowClearButton]="page.model_id !== 'ALL'"
                       ttClearValue="ALL">
                <ng-container buttons>
                    <tt-form-field-button ttIcon="fas fa-bars" ttType="primary" ttGoto="models"></tt-form-field-button>
                    <tt-form-field-button *ngIf="page.model_id !== 'ALL'" ttIcon="fas fa-chevron-right" ttType="primary" ttGoto="modelmenu" [ttGotoParms]="{ model_id: page.model_id }"></tt-form-field-button>
                </ng-container>
            </tt-select>

            <tt-button ttText="choicepossrulesrun_execute" (ttClick)="execute()" [ttLoading]="executing" ttTextAlign="center" ttType="primary" ttIcon="fas fa-sync-alt"></tt-button>

            <tt-tabs [(ttSelectedId)]="selectedView">
                <tt-tab ttId="COUNT" ttLabel="gb_choicepossrulesrun_count"></tt-tab>
                <tt-tab ttId="PRODUCTS" ttLabel="gb_choicepossrulesrun_products"></tt-tab>
            </tt-tabs>
        </tt-card>
    </ng-container>
</ng-template>

<ng-template #lists>
    <ng-container *ngIf="!!page">
        <tt-list *ngIf="selectedView === 'COUNT'" [ttData]="itemsListCounts" ttBadge="badgeinfo"></tt-list>
        <tt-list *ngIf="selectedView === 'PRODUCTS'" [ttData]="itemsListProducts" ttBadge="badgeinfo"></tt-list>
    </ng-container>
</ng-template>
